import { createTheme, ThemeOptions } from '@mui/material/styles';

export const theme = createTheme({
    primary: '#f9c94e',
    errorColor: '#EA001B',
    darkYellow: '#FCC425',
    darkBlack: '#0D0D0D',
    darkGray: '#5F5F5F',
    ligthGray: '#9E9E9E',
    lightSecond: '#EFF3F5',
    mediumGray: '#717171',
    borderColor: '#E3E4E4',
} as ThemeOptions)